import React, { useState, useEffect } from 'react';
import aiSummaryService from '../../utils/aiSummaryService';
import appScriptService from '../../utils/appScriptService';
import ConnectionDebug from '../../components/debug/ConnectionDebug';

const ContentManager = () => {
  const [loading, setLoading] = useState(true);
  const [aiConnected, setAiConnected] = useState(false);
  const [appScriptConnected, setAppScriptConnected] = useState(false);
  const [selectedModule, setSelectedModule] = useState('LM2001020230_프로그래밍언어응용');
  const [rawChunks, setRawChunks] = useState([]);
  const [aiSummaries, setAiSummaries] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [generateProgress, setGenerateProgress] = useState({ current: 0, total: 0 });
  const [isGenerating, setIsGenerating] = useState(false);
  const [showDebug, setShowDebug] = useState(false);

  // 기존 모듈 목록
  // const modules = [
  //   { id: 'LM2001020201_요구사항확인', name: '요구사항 확인' },
  //   { id: 'LM2001020205_데이터입출력구현', name: '데이터입출력구현' },
  //   { id: 'LM2001020206_통합구현', name: '통합구현' },
  //   { id: 'LM2001020208_정보시스템이행', name: '정보시스템이행' },
  //   { id: 'LM2001020209_제품소프트웨어패키징', name: '제품소프트웨어패키징' },
  //   { id: 'LM2001020211_서버프로그램구현', name: '서버프로그램구현' },
  //   { id: 'LM2001020212_인터페이스구현', name: '인터페이스구현' },
  //   { id: 'LM2001020214_애플리케이션배포', name: '애플리케이션배포' },
  //   { id: 'LM2001020217_애플리케이션리팩토링', name: '애플리케이션리팩토링' },
  //   { id: 'LM2001020218_인터페이스설계', name: '인터페이스설계' },
  //   { id: 'LM2001020219_애플리케이션요구사항분석', name: '애플리케이션요구사항분석' },
  //   { id: 'LM2001020220_기능모델링', name: '기능모델링' },
  //   { id: 'LM2001020221_애플리케이션설계', name: '애플리케이션설계' },
  //   { id: 'LM2001020222_정적모델설계', name: '정적모델설계' },
  //   { id: 'LM2001020223_동적모델설계', name: '동적모델설계' },
  //   { id: 'LM2001020224_화면설계', name: '화면설계' },
  //   { id: 'LM2001020225_화면구현', name: '화면구현' },
  //   { id: 'LM2001020226_애플리케이션테스트관리', name: '애플리케이션테스트관리' },
  //   { id: 'LM2001020227_애플리케이션테스트수행', name: '애플리케이션테스트수행' },
  //   { id: 'LM2001020228_소프트웨어공학활용', name: '소프트웨어공학활용' },
  //   { id: 'LM2001020229_소프트웨어개발방법론활용', name: '소프트웨어개발방법론활용' },
  //   { id: 'LM2001020230_프로그래밍 언어 응용', name: '프로그래밍 언어 응용' },
  //   { id: 'LM2001020231_프로그래밍 언어 활용', name: '프로그래밍 언어 활용' },
  //   { id: 'LM2001020232_응용SW 기초 기술 활용', name: '응용SW 기초 기술 활용' },
  //   { id: 'LM2001020233_개발자 환경 구축', name: '개발자 환경 구축' },
  //   { id: 'LM2001020234_개발 환경 운영 지원', name: '개발 환경 운영 지원' }
  // ];
  const modules = [
    { id: 'LM2001020230_프로그래밍언어응용', name: '프로그래밍 언어 응용' },
    { id: 'LM2001020231_프로그래밍언어활용', name: '프로그래밍 언어 활용' },
    { id: 'LM2001020224_화면설계', name: '화면설계' },
    { id: 'LM2001020225_화면구현', name: '화면구현' },
    { id: 'LM2001020211_서버프로그램구현', name: '서버프로그램구현' },
    { id: 'LM2001020227_애플리케이션테스트수행', name: '애플리케이션테스트수행' },
    { id: 'LM2001020205_데이터입출력구현', name: '데이터입출력구현' },
    { id: 'LM2001020206_통합구현', name: '통합구현' },
    { id: 'LM2001020214_애플리케이션배포', name: '애플리케이션배포' },
    { id: 'LM2001020212_인터페이스구현', name: '인터페이스구현' },
    { id: 'LM2001020234_개발 환경 운영 지원', name: '개발 환경 운영 지원' },
    { id: 'LM2001020233_개발자 환경 구축', name: '개발자 환경 구축' }
  ];

  useEffect(() => {
    initializeServices();
  }, []);

  useEffect(() => {
    loadModuleData();
  }, [selectedModule]);

  // 서비스 초기화
  const initializeServices = async () => {
    setLoading(true);

    // AI 서비스 연결 확인
    const aiValid = await aiSummaryService.validateAPIKey();
    setAiConnected(aiValid);

    // Apps Script 연결 확인
    const appScriptValid = await appScriptService.testConnection();
    setAppScriptConnected(appScriptValid);

    setLoading(false);
  };

  // 모듈 데이터 로드
  const loadModuleData = async () => {
    try {
      // 기존 JSONL 파일에서 청크 데이터 로드
      const response = await fetch('/all_chunks.jsonl');
      const text = await response.text();

      const chunks = text
        .split('\n')
        .filter(line => line.trim())
        .map(line => JSON.parse(line));

      // 선택된 모듈의 데이터만 필터링
      const moduleChunks = chunks.filter(chunk => chunk.doc_id === selectedModule);
      setRawChunks(moduleChunks);

      // 기존 AI 요약이 있는지 확인 (Apps Script에서)

      if (appScriptConnected) {

        await loadExistingAISummaries();
      } else {

        // 테스트용으로 강제 호출

        await loadExistingAISummaries();
      }

    } catch (error) {
      console.error('모듈 데이터 로드 실패:', error);
    }
  };

  // 기존 AI 요약 로드
  const loadExistingAISummaries = async () => {
    try {

      const response = await appScriptService.getData('AI요약', {
        과목코드: selectedModule
      });


      // response가 직접 배열로 오는 경우와 객체로 오는 경우를 모두 처리
      let summariesData = [];
      if (Array.isArray(response)) {
        summariesData = response;
      } else if (response?.data && Array.isArray(response.data)) {
        summariesData = response.data;
      } else if (response) {
        summariesData = [response];
      }

      setAiSummaries(summariesData);
    } catch (error) {
      console.error('기존 AI 요약 로드 실패:', error);
      setAiSummaries([]);
    }
  };

  // AI 요약 생성
  const generateAISummaries = async () => {
    if (!aiConnected) {
      alert('AI 서비스가 연결되지 않았습니다. API 키를 확인해주세요.');
      return;
    }

    setIsGenerating(true);
    setGenerateProgress({ current: 0, total: rawChunks.length });

    try {
      const results = await aiSummaryService.generateBatchSummaries(
        rawChunks,
        (current, total) => setGenerateProgress({ current, total })
      );

      // AI 요약을 화면용 형태로 변환
      const summaries = results.map(result => {
        const chunk = rawChunks.find(c => c.chunk_id === result.chunkId);
        return {
          id: result.chunkId,
          과목코드: selectedModule,
          과목명: getSelectedModuleInfo().name,
          학습단위: chunk.lesson_num,
          학습제목: chunk.lesson_title,
          토픽ID: chunk.topic_id,
          토픽명: chunk.topic_title,
          ...result.summary,
          생성일시: new Date().toISOString(),
          수정일시: new Date().toISOString(),
          aiGenerated: true,
          success: result.success
        };
      });

      setAiSummaries(summaries);

      // Apps Script에 저장
      if (appScriptConnected) {
        await appScriptService.addData('AI요약', summaries);
        alert('AI 요약이 생성되고 저장되었습니다!');
      } else {
        alert('AI 요약이 생성되었습니다! (로컬 저장만)');
      }

    } catch (error) {
      console.error('AI 요약 생성 실패:', error);
      alert('AI 요약 생성에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsGenerating(false);
      setGenerateProgress({ current: 0, total: 0 });
    }
  };

  // 요약 편집
  const handleEdit = (summary) => {
    setEditingItem({ ...summary });
  };

  // 편집 저장
  const handleSave = async () => {
    try {
      // 로컬 상태 업데이트
      const updatedSummaries = aiSummaries.map(item =>
        item.id === editingItem.id ? { ...editingItem, 수정일시: new Date().toISOString() } : item
      );
      setAiSummaries(updatedSummaries);

      // Apps Script에 업데이트
      if (appScriptConnected) {
        // 행 ID 찾기 (실제 구현에서는 더 정확한 방법 필요)
        const rowIndex = aiSummaries.findIndex(item => item.id === editingItem.id) + 2; // 헤더 행 고려
        await appScriptService.updateData('AI요약', rowIndex, editingItem);
      }

      setEditingItem(null);
      alert('저장되었습니다!');

    } catch (error) {
      console.error('저장 실패:', error);
      alert('저장에 실패했습니다.');
    }
  };

  // 요약 삭제
  const handleDelete = async (summaryId) => {
    if (!window.confirm('이 요약을 삭제하시겠습니까?')) return;

    try {
      // 로컬에서 제거
      const updatedSummaries = aiSummaries.filter(item => item.id !== summaryId);
      setAiSummaries(updatedSummaries);

      // Apps Script에서도 제거 (실제 구현 필요)
      alert('삭제되었습니다!');

    } catch (error) {
      console.error('삭제 실패:', error);
      alert('삭제에 실패했습니다.');
    }
  };

  const getSelectedModuleInfo = () => {
    return modules.find(module => module.id === selectedModule) || modules[0];
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">서비스 연결을 확인하는 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* 헤더 */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-3xl font-bold text-gray-900">📝 교사용 콘텐츠 관리</h1>
            <div className="flex gap-4 text-sm">
              <div className={`flex items-center ${aiConnected ? 'text-green-600' : 'text-red-600'}`}>
                <div className={`w-2 h-2 rounded-full mr-2 ${aiConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
                <span>AI 서비스 {aiConnected ? '연결됨' : '연결 안됨'}</span>
              </div>
              <div className={`flex items-center ${appScriptConnected ? 'text-green-600' : 'text-red-600'}`}>
                <div className={`w-2 h-2 rounded-full mr-2 ${appScriptConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
                <span>Apps Script {appScriptConnected ? '연결됨' : '연결 안됨'}</span>
              </div>
              <button
                onClick={() => setShowDebug(!showDebug)}
                className="px-3 py-1 bg-gray-600 text-white rounded text-xs hover:bg-gray-700"
              >
                🔧 디버그 {showDebug ? '숨기기' : '보기'}
              </button>
            </div>
          </div>
          <p className="text-gray-600 mb-6">
            AI가 생성한 학습 요약을 확인하고 편집할 수 있습니다.
          </p>

          {/* 컨트롤 패널 */}
          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* 모듈 선택 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  학습모듈 선택
                </label>
                <select
                  value={selectedModule}
                  onChange={(e) => setSelectedModule(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {modules.map(module => (
                    <option key={module.id} value={module.id}>
                      {module.name}
                    </option>
                  ))}
                </select>
                <p className="text-sm text-gray-500 mt-1">
                  {rawChunks.length}개 청크 데이터
                </p>
              </div>

              {/* 생성 상태 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  AI 요약 상태
                </label>
                <div className="text-2xl font-bold text-blue-600">
                  {aiSummaries.length} / {rawChunks.length}
                </div>
                <div className="text-sm text-gray-600">생성완료 / 전체</div>
              </div>

              {/* 액션 버튼 */}
              <div className="flex items-end gap-2">
                <button
                  onClick={generateAISummaries}
                  disabled={!aiConnected || isGenerating}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                >
                  {isGenerating ? '생성 중...' : '🤖 AI 요약 생성'}
                </button>
                <button
                  onClick={loadExistingAISummaries}
                  disabled={!appScriptConnected}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                >
                  🔄 새로고침
                </button>
              </div>
            </div>

            {/* 생성 진행 상태 */}
            {isGenerating && (
              <div className="mt-4">
                <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
                  <span>AI 요약 생성 진행 중...</span>
                  <span>{generateProgress.current} / {generateProgress.total}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${(generateProgress.current / generateProgress.total) * 100}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 디버그 컴포넌트 */}
        {showDebug && (
          <div className="mb-8">
            <ConnectionDebug />
          </div>
        )}

        {/* AI 요약 목록 */}
        <div className="space-y-6">
          {aiSummaries.length > 0 ? (
            aiSummaries.map((summary) => (
              <div key={summary.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                {/* 헤더 */}
                <div className={`p-4 ${summary.success !== false ? 'bg-gradient-to-r from-purple-600 to-pink-600' : 'bg-gradient-to-r from-red-600 to-orange-600'} text-white`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-bold">
                        학습 {summary.학습단위}. {summary.학습제목}
                      </h3>
                      <p className="text-purple-100">
                        {summary.토픽ID}. {summary.토픽명}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(summary)}
                        className="px-3 py-1 bg-white bg-opacity-20 rounded hover:bg-opacity-30 transition-all"
                      >
                        ✏️ 편집
                      </button>
                      <button
                        onClick={() => handleDelete(summary.id)}
                        className="px-3 py-1 bg-white bg-opacity-20 rounded hover:bg-opacity-30 transition-all"
                      >
                        🗑️ 삭제
                      </button>
                    </div>
                  </div>
                </div>

                {/* 내용 */}
                <div className="p-6">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-2">💡 핵심개념</h4>
                        <p className="text-gray-700 bg-blue-50 p-3 rounded">
                          {summary.핵심개념}
                        </p>
                      </div>

                      <div>
                        <h4 className="font-semibold text-gray-800 mb-2">🏷️ 키워드</h4>
                        <div className="flex flex-wrap gap-2">
                          {(Array.isArray(summary.키워드) ? summary.키워드 : summary.키워드?.split(',') || []).map((keyword, index) => (
                            <span key={`keyword-${summary.id}-${index}`} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm">
                              {keyword.trim()}
                            </span>
                          ))}
                        </div>
                      </div>

                      <div>
                        <h4 className="font-semibold text-gray-800 mb-2">📋 내용유형 & 중요도</h4>
                        <div className="flex gap-2">
                          {(Array.isArray(summary.내용유형) ? summary.내용유형 : summary.내용유형?.split(',') || []).map((type, index) => (
                            <span key={`type-${summary.id}-${index}`} className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm">
                              {type.trim()}
                            </span>
                          ))}
                          <span className={`px-2 py-1 rounded text-sm ${summary.중요도 === '상' ? 'bg-red-100 text-red-700' :
                              summary.중요도 === '중' ? 'bg-yellow-100 text-yellow-700' :
                                'bg-blue-100 text-blue-700'
                            }`}>
                            중요도: {summary.중요도}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-2">📝 상세설명</h4>
                        <p className="text-gray-700 bg-gray-50 p-3 rounded">
                          {summary.상세설명}
                        </p>
                      </div>

                      {summary.실무활용 && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-2">💼 실무활용</h4>
                          <p className="text-gray-700 bg-green-50 p-3 rounded">
                            {summary.실무활용}
                          </p>
                        </div>
                      )}

                      {summary.예시 && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-2">📖 예시</h4>
                          <p className="text-gray-700 bg-yellow-50 p-3 rounded">
                            {summary.예시}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 체크포인트 */}
                  {summary.체크포인트 && Array.isArray(summary.체크포인트) && summary.체크포인트.length > 0 && (
                    <div className="mt-6">
                      <h4 className="font-semibold text-gray-800 mb-2">✅ 체크포인트</h4>
                      <ul className="space-y-2">
                        {summary.체크포인트.map((point, index) => (
                          <li key={`checkpoint-${summary.id}-${index}`} className="flex items-start">
                            <span className="text-green-500 mr-2">✓</span>
                            <span className="text-gray-700">{point}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* 연관개념 */}
                  {summary.연관개념 && Array.isArray(summary.연관개념) && summary.연관개념.length > 0 && (
                    <div className="mt-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🔗 연관개념</h4>
                      <div className="flex flex-wrap gap-2">
                        {summary.연관개념.map((concept, index) => (
                          <span key={`concept-${summary.id}-${index}`} className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-sm">
                            {concept}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* 메타정보 */}
                  <div className="mt-6 pt-4 border-t border-gray-200">
                    <div className="flex justify-between text-xs text-gray-500">
                      <span>생성: {new Date(summary.생성일시).toLocaleString()}</span>
                      <span>수정: {new Date(summary.수정일시).toLocaleString()}</span>
                      {summary.success === false && (
                        <span className="text-red-500">⚠️ AI 생성 실패 (폴백 데이터)</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-12">
              <div className="text-gray-400 text-6xl mb-4">🤖</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">AI 요약이 없습니다</h3>
              <p className="text-gray-600 mb-4">AI 요약 생성 버튼을 클릭하여 학습 요약을 만들어보세요.</p>
              <button
                onClick={generateAISummaries}
                disabled={!aiConnected}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                🤖 AI 요약 생성하기
              </button>
            </div>
          )}
        </div>

        {/* 편집 모달 */}
        {editingItem && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <h3 className="text-lg font-bold mb-4">AI 요약 편집</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        핵심개념
                      </label>
                      <textarea
                        value={editingItem.핵심개념}
                        onChange={(e) => setEditingItem({ ...editingItem, 핵심개념: e.target.value })}
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        키워드 (쉼표로 구분)
                      </label>
                      <input
                        type="text"
                        value={Array.isArray(editingItem.키워드) ? editingItem.키워드.join(', ') : editingItem.키워드}
                        onChange={(e) => setEditingItem({ ...editingItem, 키워드: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        내용유형 (쉼표로 구분)
                      </label>
                      <input
                        type="text"
                        value={Array.isArray(editingItem.내용유형) ? editingItem.내용유형.join(', ') : editingItem.내용유형}
                        onChange={(e) => setEditingItem({ ...editingItem, 내용유형: e.target.value })}
                        placeholder="정의, 절차, 예시, 이론, 실무"
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        중요도
                      </label>
                      <select
                        value={editingItem.중요도}
                        onChange={(e) => setEditingItem({ ...editingItem, 중요도: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="상">상</option>
                        <option value="중">중</option>
                        <option value="하">하</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        상세설명
                      </label>
                      <textarea
                        value={editingItem.상세설명}
                        onChange={(e) => setEditingItem({ ...editingItem, 상세설명: e.target.value })}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        실무활용
                      </label>
                      <textarea
                        value={editingItem.실무활용}
                        onChange={(e) => setEditingItem({ ...editingItem, 실무활용: e.target.value })}
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        예시
                      </label>
                      <textarea
                        value={editingItem.예시}
                        onChange={(e) => setEditingItem({ ...editingItem, 예시: e.target.value })}
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => setEditingItem(null)}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                  >
                    취소
                  </button>
                  <button
                    onClick={handleSave}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    저장
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentManager;